import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'

import ScopeIndex from '@/components/ScopeIndex' // 业务首页，无导航栏
import ScopeContent from '@/components/ScopeContent' // 业务信息介绍与订单信息填写页
import ScopeSubmitOrder from '@/components/ScopeSubmitOrder' // 业务订单确认下单页
import ChooseFrequencyList from "@/components/ChooseFrequencyList" // 班次列表选择页
import MakeTicketOrder from '@/components/MakeTicketOrder' // 车票下单信息填写页面
import MyUserSetting from '@/components/MyUserSetting' // 我的乘客列表页
import MyContactManager from '@/components/MyContactManager' // 我的乘客列表页
import EditContact from '@/components/EditContact' // 修改乘客信息页
import PaymentSelector from '@/components/PaymentSelector' // 支付方式选择页
import ChoosePickupService from '@/components/ChoosePickupService' // 选择接送服务页
import MainIndexPage from '@/components/MainIndexPage' // 整合主页，有导航栏，整合ScopeIndex,MyOrderList,MyUserSetting


import FlightOrderConfirm from '@/components/FlightOrderConfirm'
import OrderResult from '@/components/OrderResult'
import City from '@/components/City'

import DetailPage from '@/components/DetailPage'
import MemberInfoInput from '@/components/MemberInfoInput'
import SubmitOrder from '@/components/SubmitOrder'
import News from '@/components/News'
import TestPage from '@/components/TestPage'
import HqPublicOrderPage from '@/components/HqPublicOrderPage'
import MyAddressManager from '@/components/MyAddressManager'
import EditAddress from '@/components/EditAddress' //编辑地址信息
import OrderPage from '@/components/OrderPage'
import MyOrderList from '@/components/MyOrderList'
import OrderDetailsInfo from '@/components/OrderDetailsInfo' // 订单详情页
import ScopeOrderDetailsInfo from '@/components/ScopeOrderDetailsInfo'
import AppointOrderDetailsInfo from '@/components/AppointOrderDetailsInfo'
import FlightOrderDetailsInfo from '@/components/FlightOrderDetailsInfo'

import AppointCarPage from '@/components/AppointCarPage'
import MakeAppointOrderPage from '@/components/MakeAppointOrderPage'

import SalesStatReport from '@/components/SalesStatReport'
import PickupReportList from '@/components/PickupReportList'
import PickupList from '@/components/PickupList'

import MakeSpecialCarOrder from '@/components/MakeSpecialCarOrder'
import CreateSpecialCarOrder from '@/components/CreateSpecialCarOrder'

import AppointQuickMakeOrder from '@/components/AppointQuickMakeOrder'
import GetOrderStatistics from '@/components/GetOrderStatistics'

// 司机相关Start
import DriverMainPage from '@/components/DriverMainPage'
import DriverInfoRegister from '@/components/DriverInfoRegister'
import DriverJobList from '@/components/DriverJobList'
import DriverJobStatistical from '@/components/DriverJobStatistical'

// import EventOrderPage from '@/components/EventOrderPage'

import NewMakeAppointOrderPage from '@/components/NewMakeAppointOrderPage'
import NewOrderPage from '@/components/NewOrderPage'
// 司机相关End


// 机票相关Start
import CompareFlightIndex from '@/components/CompareFlightIndex'
import FlightQueryIndex from '@/components/FlightQueryIndex'
import FlightNoList from '@/components/FlightNoList'
import GetFlightNoList from '@/components/GetFlightNoList'
import FlightNoDetail from '@/components/FlightNoDetail'
import FlightIndexPage from '@/components/FlightIndexPage'
import FlightOrderList from '@/components/FlightOrderList'
import FlightOrderDetail from '@/components/FlightOrderDetail'
// 机票相关End

//酒店相关
import HotelList from '@/components/HotelList'
import HotelDetail from '@/components/HotelDetail'
import HotelOrderComfirm from '@/components/HotelOrderComfirm'

//大巴查询
import BusQueryIndex from "@/components/BusQueryIndex"

//商城相关
import ShopIndexPage from '@/components/shopIndexPage'
import ShopQueryIndex from '@/components/shopQueryIndex'
// import ShopMyUser from '@/components/shopMyUser'
import ShopOrderList from '@/components/shopOrderList'
import ShopTypePage from '@/components/shopTypePage'
import ShopFlightDetail from '@/components/shopFlightDetail'
import ShopAppointment from '@/components/shopAppointment'
import AoMenShopAppointment from '@/components/aomenshopAppointment'
import TravelAppointment from '@/components/travelAppointment'
import UseCoupon from '@/components/useCoupon'
import FlightCoupon from '@/components/flightCoupon'
import ZHFlightCoupon from '@/components/zhflightCoupon'
import UrgentNotice from '@/components/UrgentNotice'
import UrgentNotice1 from '@/components/UrgentNotice1'
import UrgentNotice2 from '@/components/UrgentNotice2'
import UseCoupon1 from '@/components/useCoupon1'
import UseCoupon2 from '@/components/useCoupon2'
import travelAD1 from '@/components/travelAD1'
// import TravelDestination from '@/components/travelDestination'
// import TravelLine from '@/components/travelLine'
// import LineDetail from '@/components/lineDetail'

//二级路由组件
// import ProductListTmp from '@/components/child-components/ProductListTmp'

Vue.use(Router)

export default new Router({
	base: '/wechat/',
	routes: [
		// {path: '/',name: 'home',component: HomeNew},
		// {path: '/',name: 'home',component: Home,meta: {title: '中山市旅游集散中心'}},
		{
			path: '/detail-page',
			name: 'detail-page',
			component: DetailPage,
			meta: {
				title: '商品详情页'
			}
		},
    {
    	path: '/ShopAppointment/',
    	name: 'ShopAppointment',
    	component: ShopAppointment,
    	meta: {
    		title: '买机票送车票预约购票'
    	}
    },
    {
    	path: '/ShopAppointment/:shoporderid',
    	name: 'ShopAppointment',
    	component: ShopAppointment,
    	meta: {
    		title: '买机票送车票预约购票'
    	}
    },
    // {
    // 	path: '/travelDestination',
    // 	name: 'TravelDestination',
    // 	component: TravelDestination,
    // 	meta: {
    // 		title: '旅游目的地'
    // 	}
    // },
    // {
    // 	path: '/travelLine',
    // 	name: 'TravelLine',
    // 	component: TravelLine,
    // 	meta: {
    // 		title: '旅游线路'
    // 	}
    // },
    // {
    // 	path: '/lineDetail',
    // 	name: 'LineDetail',
    // 	component: LineDetail,
    // 	meta: {
    // 		title: '旅游线路详情'
    // 	}
    // },
    {
    	path: '/TravelAppointment/:openid',
    	name: 'TravelAppointment',
    	component: TravelAppointment,
    	meta: {
    		title: '携程旅游候机楼门店红包大放送'
    	}
    },
	{
	     path: '/UseCoupon',
	     name: 'UseCoupon',
	     component: UseCoupon,
	     meta: {
	      title: '百万红包预约使用'
	     }
	    },
	{
     path: '/FlightCoupon/:openid',
     name: 'FlightCoupon',
     component: FlightCoupon,
     meta: {
      title: '9.9元起，广州白云机场旅客专享！'
     }
    },
	{
	     path: '/ZHFlightCoupon/:openid',
	     name: 'ZHFlightCoupon',
	     component: ZHFlightCoupon,
	     meta: {
	      title: '618大促特推丨在中山候机楼买珠海始发机票，送车票！'
	     }
	},
	{
	     path: '/urgentnotice/:openid',
	     name: 'UrgentNotice',
	     component: UrgentNotice,
	     meta: {
	      title: '疫情防控 | 6月9日起调整中山候机楼⇄广州机场班次！ '
	     }
	},
	{
	     path: '/urgentnotice1/:openid',
	     name: 'UrgentNotice1',
	     component: UrgentNotice1,
	     meta: {
	      title: '7月24日起中山候机楼往返广州机场大巴恢复营运！'
	     }
	},
	{
     path: '/UseCoupon1',
     name: 'UseCoupon1',
     component: UseCoupon1,
     meta: {
      title: '学生优惠福利包'
     }
    },
    {
     path: '/UseCoupon2',
     name: 'UseCoupon2',
     component: UseCoupon2,
     meta: {
      title: '学生优惠福利包'
     }
    },
	{
	     path: '/travelAD1',
	     name: 'travelAD1',
	     component: travelAD1,
	     meta: {
	      title: '旅游VIP新品发布会'
	     }
	    },
	{
     path: '/urgentnotice2/:openid',
     name: 'UrgentNotice2',
     component: UrgentNotice2,
     meta: {
      title: '最新通知丨8月6日起，中山候机楼⇌广州机场班次调整'
     }
    },
	{
     path: '/GetOrderStatistics',
     name: 'GetOrderStatistics',
     component: GetOrderStatistics,
     meta: {
      title: ''
     }
    },
    {
    	path: '/AoMenShopAppointment',
    	name: 'AoMenShopAppointment',
    	component: AoMenShopAppointment,
    	meta: {
    		title: '政企商务机票预约下单'
    	}
    },
    {
    	path: '/AirTicket/:PlaceName',
    	name: 'FlightIndexPage',
    	component: FlightIndexPage,
    	meta: {
    		title: '机票首页'
    	}
    },
    {
    	path: '/shop',
    	name: 'shopIndexPage',
    	component: ShopIndexPage,
    	meta: {
    		title: '商城首页'
    	}
    },
    {
    	path: '/shopindex',
    	name: 'shopQueryIndex',
    	component: ShopQueryIndex,
    	meta: {
    		title: '商城产品首页'
    	}
    },
    // {
    // 	path: '/shopMyUser',
    // 	name: 'ShopMyUser',
    // 	component: ShopMyUser,
    // 	meta: {
    // 		title: '商城产品首页'
    // 	}
    // },
    {
    	path: '/ShopOrderList',
    	name: 'shopOrderList',
    	component: ShopOrderList,
    	meta: {
    		title: '我的商城订单'
    	}
    },
    {
    	path: '/ShopTypePage/:type',
    	name: 'shopTypePage',
    	component: ShopTypePage,
    	meta: {
    		title: '商城产品首页'
    	}
    },
    {
    	path: '/ShopFlightDetail/:type',
    	name: 'shopFlightDetail',
    	component: ShopFlightDetail,
    	meta: {
    		title: '商城产品首页'
    	}
    },
		{
			path: '/busQueryIndex',
			name: 'BusQueryIndex',
			component: BusQueryIndex,
			meta: {
				title: '机场大巴查询'
			}
		},
		{
			path: '/MyUserSetting',
			name: 'MyUserSetting',
			component: MyUserSetting,
			meta: {
				title: '个人中心'
			}
		},
    {
    	path: '/FlightOrderList/:name',
    	name: 'FlightOrderList',
    	component: FlightOrderList,
    	meta: {
    		title: '我的机票订单'
    	}
    },
    {
    	path: '/FlightOrderDetail/:orderNumber',
    	name: 'FlightOrderDetail',
    	component: FlightOrderDetail,
    	meta: {
    		title: ''
    	}
    },
		{
			path: '/flightindex/:name',
			name: 'FlightQueryIndex',
			component: FlightQueryIndex,
			meta: {
				title: '航班机票查询'
			}
		},
    {
    	path: '/flightlist/:name/:IsGoBack/:depcity/:arrcity/:aircompany/:flighttype/:depdate',
    	name: 'GetFlightNoList',
    	component: GetFlightNoList,
    	meta: {
    		title: '查询航班列表'
    	}
    },
		{
			path: '/flightlist/:name/:IsGoBack',
			name: 'FlightNoList',
			component: FlightNoList,
			meta: {
				title: '查询航班列表'
			}
		},
		{
			path: '/flightdetail/:name/:IsGoBack',
			name: 'FlightNoDetail',
			component: FlightNoDetail,
			meta: {
				title: '航班舱位详情'
			}
		},
		{
			path: '/hotellist/:name',
			name: 'HotelList',
			component: HotelList,
			meta: {
				title: '查询酒店列表'
			}
		},
		{
			path: '/hoteldetail',
			name: 'HotelDetail',
			component: HotelDetail,
			meta: {
				title: '查询酒店详情'
			}
		},
		{
			path: '/hotelordercomfirm',
			name: 'HotelOrderComfirm',
			component: HotelOrderComfirm,
			meta: {
				title: '查询酒店详情'
			}
		},
		// {
		// 	path: '/eventorderpage',
		// 	name: 'EventOrderPage',
		// 	component: EventOrderPage,
		// 	meta: {
		// 		title: '南航活动报名申请'
		// 	}
		// },
		// {
		// 	path: '/eventorderpage/:id',
		// 	name: 'EventOrderPage',
		// 	component: EventOrderPage,
		// 	meta: {
		// 		title: '南航活动报名申请'
		// 	}
		// },
		{
			path: '/newappointpage/:name/:limit/:back',
			name: 'NewMakeAppointOrderPage',
			component: NewMakeAppointOrderPage,
			meta: {
				title: '中山旅游集散中心合作商户约车出行'
			}
		},
		{
			path: '/neworder-page/:limit/:from',
			name: 'neworder-page',
			component: NewOrderPage,
			meta: {
				title: '请确认接送车订单信息'
			}
		},

		{
			path: '/news-page',
			name: 'news-page',
			component: News,
			meta: {
				title: '最新消息'
			}
		},
		{
			path: '/orderlst',
			name: 'MyOrderList',
			component: MyOrderList,
			meta: {
				title: '我的订单列表'
			}
		},
		{
			path: '/salesreport',
			name: 'SalesStatReport',
			component: SalesStatReport,
			meta: {
				title: '销售提成统计'
			}
		},
		{
			path: '/PickupList',
			name: 'PickupList',
			component: PickupList,
			meta: {
				title: '接送车派车'
			}
		},
		{
			path: '/pickupreport',
			name: 'PickupReportList',
			component: PickupReportList,
			meta: {
				title: '接送信息查询'
			}
		},
		{
			path: '/drivermain',
			name: 'DriverMainPage',
			component: DriverMainPage,
			meta: {
				title: '司机管理页'
			}
		},
		{
			path: '/driverregister',
			name: 'DriverInfoRegister',
			component: DriverInfoRegister,
			meta: {
				title: '司机注册'
			}
		},
		{
			path: '/driverstat',
			name: 'DriverJobStatistical',
			component: DriverJobStatistical,
			meta: {
				title: '司机工单统计'
			}
		},
		{
			path: '/driverstat/:target',
			name: 'DriverJobStatistical',
			component: DriverJobStatistical,
			meta: {
				title: '司机工单统计'
			}
		},
		{
			path: '/driverjoblist',
			name: 'DriverJobList',
			component: DriverJobList,
			meta: {
				title: '司机工单表'
			}
		},
		{
			path: '/compareFlightIndex',
			name: 'CompareFlightIndex',
			component: CompareFlightIndex,
			meta: {
				title: '机票'
			}
		},
		{
			path: '/city/:mode',
			name: 'City',
			component: City,
			meta: {
				title: '选择城市'
			}
		},
		{
			path: '/order-confirm/:name/:IsGoBack',
			name: 'order-confirm',
			component: FlightOrderConfirm,
			meta: {
				title: '机票下单确认'
			}
		},
		{
			path: '/order-result',
			name: 'order-result',
			component: OrderResult,
			meta: {
				title: '支付成功结果'
			}
		},
		{
			path: '/member-login',
			name: 'member-login',
			component: MemberInfoInput,
			meta: {
				title: '我的会员'
			}
		},
		// {path: '/',name: 'member-login',component: MemberInfoInput,meta: {title: '我的会员'}},
		{
			path: '/submit-order',
			name: 'submit-order',
			component: SubmitOrder,
			meta: {
				title: '提交订单'
			}
		},

		{
			path: '/appoint/:name',
			name: 'HqPublicOrderPage',
			component: HqPublicOrderPage,
			meta: {
				title: '中山旅游集散中心合作商户约车出行'
			}
		},
		{
			path: '/appoint/:name/:limit/:back',
			name: 'HqPublicOrderPage',
			component: HqPublicOrderPage,
			meta: {
				title: '中山旅游集散中心合作商户约车出行'
			}
		},
		{
			path: '/appoint/:name/:limit/:back/:from',
			name: 'HqPublicOrderPage',
			component: HqPublicOrderPage,
			meta: {
				title: '中山旅游集散中心合作商户约车出行'
			}
		},
		{
			path: '/appointpage/:name/:limit/:back/:from',
			name: 'AppointCarPage',
			component: AppointCarPage,
			meta: {
				title: '中山旅游集散中心合作商户约车出行'
			}
		},
		{
			path: '/quickappoint/:name/:from',
			name: 'AppointQuickMakeOrder',
			component: AppointQuickMakeOrder,
			meta: {
				title: '中山旅游集散中心合作商户约车出行'
			}
		},
		{
			path: '/submitspecialcarorder/:submitInfo/:frequencyId',
			name: 'CreateSpecialCarOrder',
			component: CreateSpecialCarOrder,
			meta: {
				title: '中山旅游集散中心红旗专车优惠体验下单'
			}
		},
		{
			path: '/specialcar/:frequencyId',
			name: 'MakeSpecialCarOrder',
			component: MakeSpecialCarOrder,
			meta: {
				title: '中山旅游集散中心红旗专车优惠体验'
			}
		},
		// {path: '/:name',name: 'public-order',component: HqPublicOrderPage,meta: {title: '请填写订单信息'}},
		{
			path: '/addresslst/:mode',
			name: 'MyAddressManager',
			component: MyAddressManager,
			meta: {
				title: '旅客接送地址管理'
			}
		},

		{
			path: '/editaddress/:type/:id',
			name: 'EditAddress',
			component: EditAddress,
			meta: {
				title: '旅客接送地址编辑'
			}
		},
		{
			path: '/order-page/:limit/:from',
			name: 'order-page',
			component: OrderPage,
			meta: {
				title: '请确认接送车订单信息'
			}
		},
		{
			path: '/makeappointorderpage/:limit/:from/:eprice',
			name: 'makeappointorderpage',
			component: MakeAppointOrderPage,
			meta: {
				title: '请确认接送车订单信息'
			}
		},
		{
			path: '/tdetail/:id',
			name: 'OrderDetailsInfo',
			component: OrderDetailsInfo,
			meta: {
				title: '用户票务订单详细信息'
			},
		},
    {
    	path: '/fdetail/:id',
    	name: 'FlightOrderDetailsInfo',
    	component: FlightOrderDetailsInfo,
    	meta: {
    		title: '用户机票务订单详细信息'
    	},
    },
		{
			path: '/sdetail/:id',
			name: 'ScopeOrderDetailsInfo',
			component: ScopeOrderDetailsInfo,
			meta: {
				title: '用户业务订单详细信息'
			},
		},
		{
			path: '/adetail/:id',
			name: 'AppointOrderDetailsInfo',
			component: AppointOrderDetailsInfo,
			meta: {
				title: '用户约车订单详细信息'
			},
		},
		{
			path: '/choosefre/:mode',
			name: 'ChooseFrequencyList',
			component: ChooseFrequencyList,
			meta: {
				title: '班次选择'
			}
		},
		{
			path: '/maketicketorder/:mode',
			name: 'MakeTicketOrder',
			component: MakeTicketOrder,
			meta: {
				title: '票务订单信息填写'
			}
		},
		{
			path: '/contactlst/:mode',
			name: 'MyContactManager',
			component: MyContactManager,
			meta: {
				title: '乘客信息管理'
			}
		},
		{
			path: '/editcontact/:type/:id',
			name: 'EditContact',
			component: EditContact,
			meta: {
				title: '乘客信息编辑'
			}
		},
		{
			path: '/pay/:id/:type',
			name: 'PaymentSelector',
			component: PaymentSelector,
			meta: {
				title: '订单支付'
			}
		},
		{
			path: '/pickupservice',
			name: 'ChoosePickupService',
			component: ChoosePickupService,
			meta: {
				title: '旅客VIP服务套餐选择'
			}
		},
		{
			path: '/scopecontent/:id',
			name: 'ScopeContent',
			component: ScopeContent,
			mata: {
				title: '商品详情'
			}
		},
		{
			path: '/scopesubmitorder/:submitInfo/:ScopeGoodsInfo/:chooseExtraList',
			name: 'ScopeSubmitOrder',
			component: ScopeSubmitOrder,
			mata: {
				title: '确认业务订单'
			}
		},
		{
			path: '/:page',
			name: 'MainIndexPage',
			component: MainIndexPage,
			meta: {
				title: '中山旅游集散中心'
			}
		},
		{
			path: '/',
			name: 'MainIndexPage',
			component: MainIndexPage,
			meta: {
				title: '中山旅游集散中心'
			}
		},
	],
	mode: "history"
})



// WEBPACK FOOTER //
// ./src/router/index.js